import type { BlockOrigin, BlockType, SurfaceDepth } from "./surface-spec";
import { GEMSALES_BLOCK_TYPES, SHARED_BLOCK_TYPES } from "./block-contract";

// Arrays and types both derive from ./block-contract (single SoT). Re-exported
// here so registry consumers keep one import surface.
export { GEMSALES_BLOCK_TYPES, SHARED_BLOCK_TYPES } from "./block-contract";

const SHARED = new Set<string>(SHARED_BLOCK_TYPES);
const GEMSALES = new Set<string>(GEMSALES_BLOCK_TYPES);

/** Blocks that assert a factual/marketing claim → must carry a merchant-approved proofRef. */
export const CLAIM_BEARING_TYPES: ReadonlySet<BlockType> = new Set<BlockType>([
  "proof",
  "comparison",
  "metric",
]);

/** Max blocks per depth: answer(1) offer(2) story(3) landing(4). */
export const DEPTH_CAPS: Record<SurfaceDepth, number> = { 1: 2, 2: 5, 3: 7, 4: 12 };

export function blockTypeOrigin(type: string): BlockOrigin | null {
  if (SHARED.has(type)) return "shared";
  if (GEMSALES.has(type)) return "gemsales";
  return null;
}

export function isRegisteredBlockType(type: string): type is BlockType {
  return SHARED.has(type) || GEMSALES.has(type);
}

export function depthCap(depth: SurfaceDepth): number {
  return DEPTH_CAPS[depth];
}

export function isSurfaceDepth(value: unknown): value is SurfaceDepth {
  return value === 1 || value === 2 || value === 3 || value === 4;
}
